/** ISO 8601 → value for `<input type="datetime-local">` (local timezone). */
export function isoToDatetimeLocalValue(iso?: string | null): string {
  const raw = iso?.trim();
  if (!raw) {
    return '';
  }
  const date = new Date(raw);
  if (Number.isNaN(date.getTime())) {
    return '';
  }
  const pad = (value: number): string => String(value).padStart(2, '0');
  return [
    `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`,
    `${pad(date.getHours())}:${pad(date.getMinutes())}`,
  ].join('T');
}

/** `<input type="datetime-local">` value → ISO 8601 (RFC3339). Empty → undefined. */
export function datetimeLocalValueToIso(value: string): string | undefined {
  const raw = value.trim();
  if (!raw) {
    return undefined;
  }
  const date = new Date(raw);
  if (Number.isNaN(date.getTime())) {
    return undefined;
  }
  return date.toISOString();
}

/** Compare ISO timestamps by minute (ignores seconds/ms drift). */
export function isoDatesEqualMinute(
  left?: string | null,
  right?: string | null,
): boolean {
  const a = left?.trim();
  const b = right?.trim();
  if (!a && !b) {
    return true;
  }
  if (!a || !b) {
    return false;
  }
  const leftDate = new Date(a);
  const rightDate = new Date(b);
  if (Number.isNaN(leftDate.getTime()) || Number.isNaN(rightDate.getTime())) {
    return a === b;
  }
  return (
    leftDate.getFullYear() === rightDate.getFullYear() &&
    leftDate.getMonth() === rightDate.getMonth() &&
    leftDate.getDate() === rightDate.getDate() &&
    leftDate.getHours() === rightDate.getHours() &&
    leftDate.getMinutes() === rightDate.getMinutes()
  );
}
